import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Footer from './Footer';


const MainLayout = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Fermer le menu quand la route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Empêcher le défilement du body quand le menu est ouvert sur mobile
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <LayoutContainer>
      <MenuButton onClick={toggleMenu}>
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </MenuButton>

      <Overlay isOpen={isMenuOpen} onClick={() => setIsMenuOpen(false)} />

      <Navigation isOpen={isMenuOpen}>
        <Logo to="/" onClick={() => setIsMenuOpen(false)}>VOLTAUTO</Logo>
        <NavList>

          {/* Nos Projets */}
          <NavItem>
            <NavLink to="/projets" active={location.pathname === '/projets'}>
              Nos Projets
            </NavLink>
          </NavItem>

          {/* Services */}
          <NavItem>
            <NavLink to="/services" active={location.pathname === '/services'}>
              Services
            </NavLink>
          </NavItem>

          {/* Actualités */}
          <NavItem>
            <NavLink to="/actualites" active={location.pathname === '/actualites'}>
              Actualités
            </NavLink>
          </NavItem>

          {/* À Propos */}
          <NavItem>
            <NavLink to="/apropos" active={location.pathname === '/apropos'}>
              À Propos
            </NavLink>
          </NavItem>

          {/*  Contact */}
          <NavItem>
            <NavLink to="/contact" active={location.pathname === '/contact'}>
              Contact
            </NavLink>
          </NavItem>


        </NavList>
      </Navigation>

      <MainContent>
        <Outlet />
      </MainContent>
      <Footer />
    </LayoutContainer>
  );
};

export default MainLayout;


const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Navigation = styled.nav`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 200px;
  padding: 2rem;
  background: white;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 250px;
    transform: translateX(${props => props.isOpen ? '0' : '100%'});
  }
`;

const MenuButton = styled.button`
  display: none;
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1001;
  background: white;
  border: none;
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    background: #f5f5f5;
  }
`;

const Overlay = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${props => props.isOpen ? 1 : 0};
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  transition: opacity 0.3s ease;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: 700;
  color: black;
  text-decoration: none;
  margin-bottom: 3rem;
  text-align: right;
  
  &:hover {
    color: #333;
  }

  @media (max-width: 768px) {
    margin-bottom: 2rem;
      margin-top: 2rem;
  }
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: right;
`;

const NavItem = styled.li`
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

const NavLink = styled(Link)`
  color: ${props => props.active ? '#000' : '#666'};
  text-decoration: none;
  font-size: 1rem;
  font-weight: ${props => props.active ? '600' : '400'};
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
  
  &:hover {
    color: black;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    right: 0;
    width: ${props => props.active ? '100%' : '0'};
    height: 2px;
    background: black;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const MainContent = styled.main`
  flex: 1;
  margin-right: 200px;
  width: calc(100% - 200px);

  @media (max-width: 768px) {
    margin-right: 0;
    width: 100%;
  }
`;